// @flow

/**
 * Module dependencies.
 */

import About from 'client/containers/about';
import App from 'client/containers/app';
import Compliance from 'client/containers/compliance';
import Contacts from 'client/containers/contacts';
import ForAgents from 'client/containers/for-agents';
import Home from 'client/containers/home';
import HowItWorks from 'client/containers/how-it-works';
import LicensedRepresentatives from 'client/containers/licensed-representatives';
import NotFound from 'client/containers/not-found';

/**
 * Export `containers`.
 */

export const containers = {
  About,
  App,
  Compliance,
  Contacts,
  ForAgents,
  Home,
  HowItWorks,
  LicensedRepresentatives,
  NotFound
};



// WEBPACK FOOTER //
// ../src/client/containers/index.js